<rt-input
  #timeDropdownTrigger="rtOverlayOrigin"
  [formControl]="internalControl"
  [invalid]="internalControl.dirty && (!input.control.valid || !internalControl.valid)"
  [class.dropdownOpened]="timeDropdown.open"
  [hasDropdownIndicator]="true"
  (click)="timeDropdown.open = !timeDropdown.open"
  rt-overlay-origin
  variant="rounded"
>
</rt-input>
<ng-template
  #timeDropdown="rtConnectedOverlay"
  [origin]="timeDropdownTrigger"
  [width]="120"
  (backdropClick)="timeDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-time-picker-dropdown
    [timeInterval]="15"
    [currentSelected]="input.control.value"
    (timeSelect)="valueChange($event)"
  ></rt-time-picker-dropdown>
</ng-template>
